export enum AccessibilityHtmlTags {
  MainHeader = 'h1',
  SecondaryHeader = 'h2',
  Paragraph = 'p',
}
